import {
  ConversationsChannels,
  ConversationStatus,
} from 'lib-shared-legacy-types';

export type ConversationCloseButtonMode = 'close' | 'end';

export const getConversationCloseButtonMode = (
  status: ConversationStatus | null,
  initialChannel?: ConversationsChannels | null,
  isEndUserConnected?: boolean,
): ConversationCloseButtonMode =>
  isEndUserConnected &&
  (status === 'awaitingpending' ||
    (status === 'open' && initialChannel !== 'email'))
    ? 'end'
    : 'close';
